module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO05LasMetasDebenSer.b022671.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO05LasMetasDebenSer.mp4
// module id = 733
// module chunks = 1